module.exports = __webpack_public_path__ + "img/1.607c2348.jpg";